module.exports = __webpack_public_path__ + "static/media/Artboard14.c759880c.png";